import React from 'react';
import { useXFBML } from '@/common/deferSdk/FbSdk';

function FacebookPostModule({ url, type = 'fb-post' }) {
    const parseContainer = useXFBML();

    return (
        <div className="markdown-module" ref={parseContainer} data-atid="markdown-facebook-post">
            <div className={type} data-href={url} data-show-text="true" />
        </div>
    );
}

export default FacebookPostModule;
